import { LoginSignupTypes } from '@/redux/modules/modal';

export const getItemContextMessageIds = (contextType: LoginSignupTypes) => {
    let headerMessageId;
    let blurbMessageId;

    switch (contextType) {
        case 'save item':
            headerMessageId = 'signUpModal.love';
            blurbMessageId = 'signUpModal.track';
            break;
        case 'place bid':
            headerMessageId = 'signUpModal.ready';
            blurbMessageId = 'signUpModal.placeBid';
            break;
        case 'ask a question - item':
            headerMessageId = 'signUpModal.question';
            blurbMessageId = 'signUpModal.sendQuestion';
            break;
        case 'register for auction - item':
            headerMessageId = 'signUpModal.getApproved';
            blurbMessageId = 'signUpModal.registerApprove';
            break;
        case 'see sold price':
        default:
            headerMessageId = 'signUpModal.worth';
            blurbMessageId = 'signUpModal.access';
            break;
    }

    return [headerMessageId, blurbMessageId];
};

export const getAuctioneerContextMessageIds = (contextType: LoginSignupTypes) => {
    let headerMessageId;
    let blurbMessageId;

    switch (contextType) {
        case 'ask a question - auctioneer':
            headerMessageId = 'signUpModal.question';
            blurbMessageId = 'signUpModal.sendQuestion';
            break;
        case 'follow auctioneer':
        default:
            headerMessageId = 'signUpModal.followAuctioneer';
            blurbMessageId = 'signUpModal.getAlerts';
            break;
    }

    return [headerMessageId, blurbMessageId];
};

export const getFollowContextMessageIds = (contextType: LoginSignupTypes) => {
    let headerMessageId;
    let blurbMessageId;

    switch (contextType) {
        case 'follow search':
        default:
            headerMessageId = 'signUpModal.followSearch';
            blurbMessageId = 'signUpModal.getSearchAlerts';
            break;
    }

    return [headerMessageId, blurbMessageId];
};
